import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import appServices from "../../services/app-services/appServices";

const initialState: any = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  postTypeOne: [], //facilitator posts
  postTypeZero: [], //every ones posts
};

interface PostType {
  [key: string]: number;
}

interface Category {
  id: number;
  name: string;
  jp_name: string;
  post_types: {
    [key: string]: PostType;
  };
}

interface TransformedData {
  zero: {
    category: string;
    jp_name: string;
    data: { name: string; jp_name: string; count: number }[];
  }[];
  one: {
    category: string;
    jp_name: string;
    data: { name: string; jp_name: string; count: number }[];
  }[];
}

export const getDashboard = createAsyncThunk(
  "posts/dashboard",
  async (_, thunkAPI) => {
    try {
      return await appServices.getDashboard();
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const dashboardReducer = createSlice({
  name: "posts/dashboard",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboard.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDashboard.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const response = action.payload;
        const transformedData: TransformedData = { zero: [], one: [] };
        response.forEach((category: Category) => {
          const categoryData0: { name: string; jp_name: string; count: number }[] = [];
          const categoryData1: { name: string; jp_name: string; count: number }[] = [];

          const names = [
            { name: "posts", jp_name: "投稿" },
            { name: "views", jp_name: "ビュー" },
            { name: "post_likes", jp_name: "いいね！" },
            { name: "votes", jp_name: "投票" },
            { name: "comments", jp_name: "コメント" },
          ];

          const postType0 = category.post_types["0"];
          names.forEach(({ name, jp_name }) => {
            if (name !== "views") categoryData0.push({ name, jp_name, count: postType0[name] });
          });

          const postType1 = category.post_types["1"];
          names.forEach(({ name, jp_name }) => {
            if (name !== "views") categoryData1.push({ name, jp_name, count: postType1[name] });
          });

          transformedData.zero.push({
            category: category.name,
            jp_name: category.jp_name,
            data: categoryData0,
          });
          transformedData.one.push({
            category: category.name,
            jp_name: category.jp_name,
            data: categoryData1,
          });
        });
        state.postTypeOne = transformedData.one;
        state.postTypeZero = transformedData.zero;
      })
      .addCase(getDashboard.rejected, (state: any, action) => {
        state.isLoading = false;
        state.isError = true;
      })
  },
});

export const { reset } = dashboardReducer.actions;

export default dashboardReducer.reducer;
